import React from "react";

function Icon({color = '#202F46', ...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="14"
      fill="none"
      viewBox="0 0 23 14"
      {...props}
    >
      <path
        fill={color}
        d="M1 6.15a.85.85 0 000 1.7v-1.7zm21.601 1.451a.85.85 0 000-1.202l-5.41-5.41a.85.85 0 00-1.201 1.203L20.798 7l-4.808 4.808a.85.85 0 101.202 1.202L22.6 7.601zM1 7.85h21v-1.7H1v1.7z"
      ></path>
    </svg>
  );
}

export default Icon;
